
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';

const DatosPrivados = ({ lang, cliente, idiomas, paises, tiposdocs, reservas, faqs, ruta, config }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else if (lang == "pt")
        registerLocale('pt', pt)
    else if (lang == "ru")
        registerLocale('ru', ru)
    else
        registerLocale('es', es)

    const [activeSeccion, setActiveSeccion] = useState("HOME");

    const [faqOpen, setFaqOpen] = useState(null);

    function getArrayCookie(nombre) {
        let nombreCookie = `${nombre}=`;
        let cookiesDecodificadas = decodeURIComponent(document.cookie);
        let arrayCookies = cookiesDecodificadas.split(';');

        for (let i = 0; i < arrayCookies.length; i++) {
            let cookie = arrayCookies[i].trim();
            if (cookie.indexOf(nombreCookie) === 0) {
                try {
                    return JSON.parse(cookie.substring(nombreCookie.length, cookie.length));
                } catch (e) {
                    console.error('Error parseando cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    {/* ******* */ }

    function borrarCookie(nombre) {
        let date = new Date();
        date.setTime(date.getTime() - 1);
        document.cookie = nombre + "=; expires=" + date.toGMTString() + "; path=/; domain=" + window.location.hostname;
        window.location.href = "/" + preidioma;
    }

    {/* ******* */ }

    const secciones = {
        "HOME": "AREA PRIVADA",
        "MI PERFIL": "MI PERFIL",
        "TARJETA DE SOCIO": "TARJETA DE SOCIO",
        "MIS PUNTOS": "MIS PUNTOS",
        "MIS RESERVAS": "MIS RESERVAS",
        "PROMOCIONES": "DESCUBRE QUE TENEMOS PARA TÍ",
        "NOTIFICACIONES": "NO TE PIERDAS NADA",
        "AYUDA": "¿ALGUNA DUDA?"
    };

    const cookieValue = getArrayCookie("datos");

    return (
        <>
            <div className="rw-ap-container">
                <rw-ap-menu>
                    <div className="rw-ap-menu bg-essential">
                        <button type="button" aria-controls="collapseExample" className="btn rw-ap-menu_name" aria-expanded="true">
                            <strong >HOLA, {cliente.nombre + " " + cliente.apellidos}</strong>
                            <span className="d-md-none"> menú <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-down-white.svg" />
                            </span>
                        </button>
                        <div className="collapse show">
                            <p className="o-rw-title-category">Tu categoría actual es: <br />
                                <span >ESSENTIAL</span>
                            </p>
                            <ul >
                                <li >
                                    <a data-tag="log_mgr_nav_home" className={`rw-ap-menu_link ${activeSeccion == "HOME" ? "active" : ""}`} onClick={() => setActiveSeccion("HOME")}>
                                        <i className="fa-solid fa-home" style={{ marginRight: "5px" }}></i>{" "}{t("HOME")}
                                    </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_prof" className={`rw-ap-menu_link ${activeSeccion == "MI PERFIL" ? "active" : ""}`} onClick={() => setActiveSeccion("MI PERFIL")}>
                                        <i className="fa-solid fa-user" style={{ marginRight: "5px" }}></i>{" "}{t("MI PERFIL")}
                                    </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_card" className={`rw-ap-menu_link ${activeSeccion == "TARJETA DE SOCIO" ? "active" : ""}`} onClick={() => setActiveSeccion("TARJETA DE SOCIO")}>
                                        <i className="fa-solid fa-credit-card" style={{ marginRight: "5px" }}></i>{" "}{t("TARJETA DE SOCIO")}
                                    </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_pts" className={`rw-ap-menu_link ${activeSeccion == "MIS PUNTOS" ? "active" : ""}`} onClick={() => setActiveSeccion("MIS PUNTOS")}>
                                        <i className="fa-solid fa-star" style={{ marginRight: "5px" }}></i>{" "}{t("MIS PUNTOS")} </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_res" className={`rw-ap-menu_link ${activeSeccion == "MIS RESERVAS" ? "active" : ""}`} onClick={() => setActiveSeccion("MIS RESERVAS")}>
                                        <i className="fa-solid fa-calendar" style={{ marginRight: "5px" }}></i>{" "}{t("MIS RESERVAS")} </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_promo" className={`rw-ap-menu_link ${activeSeccion == "PROMOCIONES" ? "active" : ""}`} onClick={() => setActiveSeccion("PROMOCIONES")}>
                                        <i className="fa-solid fa-percent" style={{ marginRight: "5px" }}></i>{" "}{t("PROMOCIONES")} </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_notif" className={`rw-ap-menu_link ${activeSeccion == "NOTIFICACIONES" ? "active" : ""}`} onClick={() => setActiveSeccion("NOTIFICACIONES")}>
                                        <span className="rw-ap-menu_noti">
                                            <i className="fa-solid fa-bell" style={{ marginRight: "5px" }}></i>
                                        </span> {" "}{t("NOTIFICACIONES")} </a>
                                </li>
                                <li >
                                    <a routerlinkactive="active" data-tag="log_mgr_nav_help" className={`rw-ap-menu_link ${activeSeccion == "AYUDA" ? "active" : ""}`} onClick={() => setActiveSeccion("AYUDA")}>
                                        <i className="fa-solid fa-circle-question" style={{ marginRight: "5px" }}></i> {" "}{t("AYUDA")} </a>
                                </li>
                            </ul>
                            <a data-tag="log_mgr_nav_out" className="mt-2 btn rw-ap-menu_close-sesion" onClick={() => borrarCookie("datos")}>{t("Cerrar sesión")}</a>
                        </div>
                    </div>

                </rw-ap-menu>

                <div className="mb-5 rw-ap-container_content">
                    <rw-ap-header>
                        <div className="rw-ap-header d-none d-md-flex">
                            <figure className="rw-ap-header_back">
                                {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/Cabecera_AreaPrivH10Rewards52.jpg" alt="" />*/}
                                <img loading="lazy" src="/images/web/valesuites/playa-micuenta.png" alt="" />
                            </figure>
                            <div className="container">
                                <figure className="logo">
                                    {
                                        config.logo !== "" ?
                                            <img loading="lazy" alt="" className="logo" src={ruta + "/web/logo/web/" + config.logo} />
                                            :
                                            config.logo_fiscal != "" ?
                                                <img loading="lazy" alt="" className="logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                :
                                                <img loading="lazy" alt="" className="logo" src="https://www.bedloop.com/imatges/logo.webp" />
                                    }
                                </figure>

                                <h1 className="mb-0 text-center h2">{t(secciones[activeSeccion])}</h1>
                                <div></div>
                            </div>
                        </div>
                    </rw-ap-header>
                    <div className="container">
                        <rw-ap-info-titular>
                            <div className="row rw-info-titular">
                                <div className="col-lg-4">
                                    <p className="mb-0 o-rw-title-category name"> {t("TITULAR")} <br />
                                        <span>{cliente.nombre + " " + cliente.apellidos}</span>
                                    </p>
                                    <p className="mb-0 color-h10grey">{t("Miembro desde") + " " + new Date(cliente.created_at).toLocaleDateString("es-ES", {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    })}</p>
                                    <p className="flex-wrap mb-0 d-flex align-items-baseline color-h10grey column-gap-2"> {t("Número de tarjeta")}:
                                        <button type="button" className="mb-1 btn btn-copy color-h10grey">
                                            {cliente.id} <i className="fa-solid fa-copy"></i>
                                        </button>
                                    </p>
                                </div>
                                <div className="col-lg-8">
                                    <p className="mb-0">{t("CATEGORÍA")}</p>
                                    <div className="rw-info-titular_categorias">
                                        <p className="mb-2 text-center small color-h10grey mb-md-3">
                                            <span className="rw-font-heading text-essential">ESSENTIAL</span>
                                            <br />
                                            <span className="d-none d-md-block">{t("DESDE EL PRIMER DÍA")}</span>
                                        </p>
                                        <p className="mb-2 text-center small color-h10grey mb-md-3">
                                            <span className="rw-font-heading text-silver">SILVER</span>
                                            <br />
                                            <span className="d-none d-md-block">{t("A PARTIR DE 5 NOCHES O 3 ESTANCIAS")}</span>
                                        </p>
                                        <p className="mb-2 text-center small color-h10grey mb-md-3">
                                            <span className="rw-font-heading text-gold">GOLD</span>
                                            <br />
                                            <span className="d-none d-md-block">{t("A PARTIR DE 25 NOCHES O 15 ESTANCIAS")}</span>
                                        </p>
                                        <p className="mb-2 text-center small color-h10grey mb-md-3">
                                            <span className="rw-font-heading text-platinum">PLATINUM</span>
                                            <br />
                                            <span className="d-none d-md-block">{t("A PARTIR DE 40 NOCHES O 25 ESTANCIAS")}</span>
                                        </p>

                                    </div>
                                    <div className="o-rw-progress-categoria">
                                        <div className="o-rw-progress-categoria_bar" style={{ width: "12%", backgroundColor: "rgb(163, 199, 210)" }}>
                                            <span className="o-rw-progress-categoria_indicator d-none d-lg-block indicator-left"> 0 {t("noches y")} 0 {t("estancias")} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4 row rw-info-titular puntos" style={{ display: activeSeccion === "HOME" || activeSeccion === "MIS PUNTOS" ? "block" : "none" }}>
                                <div className="col-lg-5 col-xl-4">
                                    <div>
                                        <p className="mb-0 text-xl font-heading">100 PUNTOS = 4 € </p>

                                    </div>
                                </div>
                                <div className="col-lg-7 col-xl-8">
                                    <div className="gap-4 d-flex justify-content-between">
                                        <div className="d-flex cont-text-num">
                                            <p className="rw-info-titular_text-num">
                                                <i className="fa-solid fa-moon"></i> {t("NOCHES")} <br />
                                                <span className="text-xl font-heading">0</span>
                                            </p>
                                            <p className="rw-info-titular_text-num">
                                                <i className="fa-solid fa-bed"></i> {t("ESTANCIAS")} <br />
                                                <span className="text-xl font-heading">{reservas.length}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <span className="mb-2 d-flex align-items-md-center gap1">
                                        <i className="fa-solid fa-trophy"></i>
                                        <p className="mb-0 ms-1">{t("Estás a")} <strong>0 {t("noches o ")} 0 {t("estancias")}</strong> {t("de alcanzar la categoría") + " " + t("SILVER")}. </p>
                                    </span>


                                </div>
                            </div>
                        </rw-ap-info-titular>
                        <router-outlet></router-outlet>

                        {/* <rw-area-privada-home style={{ display: activeSeccion === "HOME" ? "block" : "none" }}>
                            <p className="mb-4 fs-md-16"> {t("VENTAJAS")} ESSENTIAL</p>

                            <div className="mb-4 c-rw-swiper-cards_cont border-bottom-dark">
                                <div className="overflow">
                                    <div init="false" className="c-rw-swiper-cards" style={{ display: "flex" }}>
                                        <div className="active swiper-slide-active swiper-slide" style={{ width: "342px" }} role="group" aria-label="1 / 3">
                                            <div className="c-rw-card r-16-9">
                                                <figure className="mb-3 c-rw-card_img">
                                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/Icon_REGALO_Blanco.svg" alt="" />

                                                    <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APriv_Ventaja_ObsequioBienvenida.jpg" alt="" />
                                                </figure>
                                                <p className="c-rw-card_title">{t("Obsequio de bienvenida")}</p>
                                            </div>
                                        </div>
                                        <div className="active swiper-slide-next swiper-slide" style={{ width: "342px" }} role="group" aria-label="2 / 3">
                                            <div className="c-rw-card r-16-9">
                                                <figure className="mb-3 c-rw-card_img">
                                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/Icon_REGALO_Blanco.svg" alt="" />

                                                    <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APriv_Ventaja_Cumpleanos.jpg" alt="" />
                                                </figure>
                                                <p className="c-rw-card_title">{t("Regalo de cumpleaños Vale Rewards")}</p>
                                            </div>
                                        </div>
                                        <div className="active swiper-slide" style={{ width: "342px" }} role="group" aria-label="3 / 3">
                                            <div className="c-rw-card r-16-9">
                                                <figure className="mb-3 c-rw-card_img">
                                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/Icon_CENA_Blanco.svg" alt="" />

                                                    <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APriv_Ventaja_Agua.jpg" alt="" />
                                                </figure>
                                                <p className="c-rw-card_title">{t("Botella de agua de cortesía")}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="c-rw-swiper-cards_nav nav-beneficios d-md-none">
                                    <button className="btn prev swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-928c956c8839f4f3" aria-disabled="true">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </button>
                                    <button className="btn next swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-928c956c8839f4f3" aria-disabled="true">
                                        <i className="fa-solid fa-arrow-left"></i>
                                    </button>
                                </div>
                            </div>
                            <p className="mb-4 fs-md-16">{t("DESCUENTOS")} ESSENTIAL</p>

                            <div className="c-rw-swiper-cards_cont mb-md-9">
                                <div className="overflow">
                                    <div init="false" className="c-rw-swiper-cards" style={{ display: "flex" }}>
                                        <div className="active swiper-slide-active swiper-slide" style={{ width: "342px" }} role="group" aria-label="1 / 1">
                                            <div className="c-rw-card r-16-9">
                                                <figure className="mb-3 c-rw-card_img">
                                                    <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/Icon_DESCUENTO_Blanco.svg" alt="" />

                                                    <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T2D3/H10Rewards_APriv_Descuento_5Dto.jpg" alt="" />
                                                </figure>
                                                <p className="c-rw-card_title">{t("5% de dto. garantizado en todas las reservas realizadas en nuestras webs")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="c-rw-swiper-cards_nav nav-descuentos d-md-none">
                                    <button className="btn prev swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-bfd7e0df8510ffa97" aria-disabled="true">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </button>
                                    <button className="btn next swiper-button-disabled swiper-button-lock" disabled="" tabIndex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-bfd7e0df8510ffa97" aria-disabled="true">
                                        <i className="fa-solid fa-arrow-left"></i>
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex flex-column align-items-center">
                                <p className="mb-4 text-center">Descubre las ventajas de todas las categorías.</p>
                                <button className="btn rw-btn btn-rewards" style={{ borderRadius: "2.6em" }}>SABER MÁS</button>
                            </div>

                        </rw-area-privada-home>*/}

                        <rw-area-privada-profile style={{ display: activeSeccion === "MI PERFIL" ? "block" : "none" }}>

                            <form noValidate="" className="mt-6 mb-6 c-rw-ap-perfil mb-md-1000 mt-md-0 ng-untouched ng-pristine ng-valid">
                                <fieldset className="pb-5 mb-4">
                                    <legend>{t("Datos personales")}</legend>
                                    <div className="row small-gutters">
                                        <div className="mb-2 col-sm-4 col-md-4 mb-md-3">
                                            <label htmlFor="nombre" className="o-rw-label" title="Nombre*">{t("Nombre")}*</label>
                                            <input maxLength="30" type="text" formcontrolname="name" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.nombre} />
                                        </div>
                                        <div className="mb-2 col-sm-4 col-md-4 mb-md-3">
                                            <label htmlFor="primer_apellido" className="o-rw-label" title="Primer apellido*">{t("Primer apellido")}* </label>
                                            <input maxLength="30" type="text" id="primer_apellido" formcontrolname="surname" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.apellidos} />
                                        </div>
                                        <div className="mb-2 col-sm-4 col-md-4 mb-md-3">
                                            <label htmlFor="segundo_apellido" className="o-rw-label" title="Segundo apellido">{t("Segundo apellido")} </label>
                                            <input maxLength="30" type="text" id="segundo_apellido" formcontrolname="secondSurname" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" />
                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <label className="o-rw-label" title="Teléfono*">{t("Teléfono")}*</label>
                                            <input
                                                maxLength="30"
                                                id="telf"
                                                name="phone"
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                    this.setState({ phone: onlyNumbers.slice(0, 30) });
                                                }}
                                                data-qm-block="true"
                                                className="form-control o-rw-input"
                                                defaultValue={cliente.telefono} />
                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <div className="form-input">
                                                <label htmlFor="fecha" className="o-rw-label" title="Fecha de nacimiento*">{t("Fecha de nacimiento")}*</label>
                                                <app-date-mask-input>
                                                    <DatePicker
                                                        isClearable={true}
                                                        selected={cliente.fecha_nacimiento
                                                            ? new Date(cliente.fecha_nacimiento)
                                                            : null
                                                        }
                                                        monthsShown={1}
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText={t("DD/MM/YYYY")}
                                                        locale={lang}
                                                        name="fecha"
                                                        id="fecha"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        className="form-control cpointer noborder fs1"
                                                        autoComplete="off"
                                                        onChange={(date) => {
                                                            // Aquí manejas el cambio de fecha si necesitas actualizar el estado
                                                            // Por ejemplo: setCliente(prev => ({ ...prev, fecha_nacimiento: date }))
                                                        }}
                                                    >
                                                    </DatePicker>
                                                </app-date-mask-input>
                                            </div>
                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <label htmlFor="country" className="o-rw-label" title="Nacionalidad*">{t("Nacionalidad")}*</label>
                                            <select formcontrolname="country" className="form-select o-rw-select ng-untouched ng-pristine ng-valid" id="country">
                                                {paises.map((unpais) => (
                                                    <option
                                                        value={unpais.id}
                                                        key={unpais.id}
                                                        selected={unpais.id == cliente.nacionalidad}
                                                    >
                                                        {unpais.nombre}
                                                    </option>
                                                ))
                                                }
                                            </select>

                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <label htmlFor="country" className="o-rw-label" title="País de residencia*">{t("País de residencia")}*</label>
                                            <select formcontrolname="country" className="form-select o-rw-select ng-untouched ng-pristine ng-valid" id="country">
                                                {paises.map((unpais) => (
                                                    <option
                                                        value={unpais.id}
                                                        key={unpais.id}
                                                        selected={unpais.id == cliente.pais_id}
                                                    >
                                                        {unpais.nombre}
                                                    </option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <label className="o-rw-label" title="Tipo de documento">{t("Tipo de documento")}</label>
                                            <select id="pay_doctype" name="pay_doctype" formcontrolname="documentType" data-qm-block="true" className="form-select ng-untouched ng-pristine" disabled="">
                                                {tiposdocs.map((untipodoc) => (
                                                    <option
                                                        value={untipodoc.id}
                                                        key={untipodoc.id}
                                                        selected={untipodoc.id == cliente.tipo_documento_id}
                                                    >
                                                        {untipodoc.nombre}
                                                    </option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-sm-6 col-md-4">
                                            <label className="o-rw-label" title="Número de documento*">{t("Número de documento")}*</label>
                                            <input type="text" formcontrolname="document" maxLength="16" data-qm-block="true" className="form-control ng-untouched ng-pristine" disabled="" defaultValue={cliente.documento_identidad} />
                                        </div>
                                        <div className="mb-2 col-sm-6 col-md-4 mb-md-3">
                                            <label htmlFor="direccion" className="form-label o-rw-label" title="Dirección">{t("Dirección")} </label>
                                            <input maxLength="60" type="text" id="direccion" formcontrolname="address" data-qm-block="true" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.direccion} />
                                        </div>
                                        <div className="mb-2 col-sm-6 col-md-4 mb-md-3">
                                            <label htmlFor="provincia" className="form-label o-rw-label" title="Provincia">{t("Provincia")} </label>
                                            <input maxLength="60" type="text" id="provincia" formcontrolname="provincia" data-qm-block="true" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.provincia} />

                                        </div>
                                        <div className="mb-2 col-sm-6 col-md-4 mb-md-3">
                                            <label htmlFor="localidad" className="form-label o-rw-label" title="Localidad">{t("Localidad")} </label>
                                            <input maxLength="40" type="text" id="localidad" formcontrolname="city" data-qm-block="true" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.ciudad} />
                                        </div>
                                        <div className="mb-2 col-sm-6 col-md-4 mb-md-3 mb-md-0">
                                            <label htmlFor="codigo_postal" className="form-label o-rw-label" title="Código postal">{t("Código postal")} </label>
                                            <input maxLength="10" type="text" id="codigo_postal" formcontrolname="postalCode" data-qm-block="true" apprestrictchars="" className="form-control o-rw-input ng-untouched ng-pristine ng-valid" defaultValue={cliente.codigo_postal} />
                                        </div>
                                        <div className="mb-2 col-sm-6 col-md-4 mb-md-3">
                                            <label htmlFor="fecha" className="form-label o-rw-label" title="E-mail">{t("E-mail")}</label>
                                            <input type="email" formcontrolname="email" id="email_comunicaciones" data-qm-block="true" className="form-control ng-untouched ng-pristine" disabled="" defaultValue={cliente.email} />
                                        </div>
                                        <div className="mb-3 col-sm-6 col-md-4">
                                            <label htmlFor="communicationLanguage" className="o-rw-label" title="Idioma de las comunicaciones">{t("Idioma de las comunicaciones")}</label>
                                            <select formcontrolname="communicationLanguage" className="form-select o-rw-select ng-untouched ng-pristine ng-valid" id="communicationLanguage">
                                                {idiomas.map((unidioma) => (
                                                    <option
                                                        value={unidioma.id}
                                                        key={unidioma.id}
                                                        selected={unidioma.id == cliente.idioma}
                                                    >
                                                        {unidioma.nombre}
                                                    </option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                        <div className="mb-3 col-sm-12 col-md-12">
                                            <legend className="mb-2">{t("Mis preferencias de comunicaciones")}</legend>
                                            <p className="mb-4">{t("Para poder recibir promociones exclusivas, novedades y no perderte nada, permítenos contactarte.")}</p>
                                            <div className="form-check o-rw-check">
                                                <input type="checkbox" id="ofertas" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                                <label htmlFor="ofertas" className="form-check-label">
                                                    <span>
                                                        <p>{t("Acepto recibir comunicaciones comerciales de Vale Suites")}</p>
                                                    </span>
                                                </label>
                                            </div>

                                        </div>
                                        <div className="mt-4 mb-2 col-12 mb-md-3 mb-md-0 mt-md-0 d-flex justify-content-center align-items-center justify-content-md-end align-items-md-end">
                                            <button type="submit" className="btn rw-btn btn-rewards" disabled="">{t("GUARDAR CAMBIOS")}</button>
                                        </div>
                                    </div>
                                </fieldset>
                            </form>


                        </rw-area-privada-profile>

                        <rw-area-privada-card style={{ display: activeSeccion === "TARJETA DE SOCIO" ? "block" : "none" }}>
                            <div className="mt-6 row">
                                <div className="col-lg-6">
                                    <div className="mx-auto c-rw-card-socio mx-lg-0 bg-essential">
                                        {
                                            config.logo !== "" ?
                                                <img alt="Logo rewards" className="c-rw-card-socio_logo" src={ruta + "/web/logo/web/" + config.logo} />
                                                :
                                                config.logo_fiscal != "" ?
                                                    <img alt="Logo rewards" className="c-rw-card-socio_logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                    :
                                                    <img alt="Logo rewards" className="c-rw-card-socio_logo" src="https://www.bedloop.com/imatges/logo.webp" />
                                        }
                                        <p className="font-heading mb-md-0 c-rw-card-socio_name">{cliente.nombre + " " + cliente.apellidos}</p>
                                        <p className="c-rw-card-socio_number">
                                            <span className="fw-semibold">{t("TARJETA DE SOCIO")}</span> {cliente.id}
                                        </p>
                                        <p className="mb-0 font-heading c-rw-card-socio_category">ESSENTIAL</p>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <p className="mt-4 mb-4 text-center text-md mb-xl-6 text-lg-start ps-lg-5"></p>

                                </div>
                            </div>
                            <div className="mt-5 mb-5 row mb-md-100 mt-md-80">
                                <div className="mb-4 col-sm-6 pe-xl-4 mb-xl-0">
                                    <p>{t("VENTAJAS")} ESSENTIAL</p>
                                    <ul className="o-rw-list o-rw-list-row">
                                        <li className="gap-3 d-flex align-items-center">
                                            <figure>
                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" alt="" />
                                            </figure> {t("Obsequio de bienvenida")}
                                        </li>
                                        <li className="gap-3 d-flex align-items-center">
                                            <figure>
                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_CENA_Negro.svg" alt="" />
                                            </figure> {t("Botella de agua de cortesía")}
                                        </li>
                                        <li className="gap-3 d-flex align-items-center">
                                            <figure>
                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" alt="" />
                                            </figure> {t("Regalo de cumpleaños Vale Rewards")}
                                        </li>

                                    </ul>
                                </div>

                                <div className="col-sm-6 ps-xl-4">
                                    <p>{t("DESCUENTOS")} ESSENTIAL</p>
                                    <ul className="o-rw-list o-rw-list-row">
                                        <li className="gap-3 d-flex align-items-center">
                                            <figure>
                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_DESCUENTO_Negro.svg" alt="" />
                                            </figure> {t("5% de dto. garantizado en todas las reservas realizadas en nuestras webs")}
                                        </li>

                                    </ul>
                                </div>

                            </div>

                        </rw-area-privada-card>

                        <rw-area-privada-points style={{ display: activeSeccion === "MIS PUNTOS" ? "block" : "none" }}>
                            <div className="gap-4 mb-4 d-flex gap-md-0 flex-column flex-md-row align-items-md-center justify-content-between mb-md-6">
                                <p className="mb-0 text-16">
                                    <strong>{t("HISTORIAL DE MOVIMIENTO")}</strong>
                                </p>
                                <div ngbdropdown="" className="o-rw-dropdown dropdown">
                                    <button type="button" id="dropdownBasic1" ngbdropdowntoggle="" className="mx-auto dropdown-toggle btn rw-btn btn-drop me-md-2 show" aria-expanded="false">
                                        {t("Buscar por fecha")}

                                        <img loading="lazy" alt="Icono chevron down" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-down-grey.svg" />

                                    </button>
                                    <div ngbdropdownmenu="" aria-labelledby="dropdownBasic1" className="dropdown-menu dropdown-menu-end">
                                        <button className="btn btn-close d-md-none"></button>

                                    </div>
                                </div>

                            </div>

                            <table className="o-rw-table">
                                <thead>
                                    <tr>
                                        <th className="text-start">
                                            <strong>{t("Fecha")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Concepto")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Puntos totales")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Noches")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Fecha caducidad")}</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="d-md-none">
                                                <strong>{t("Fecha")}</strong>
                                            </span>24/04/26
                                        </td>
                                        <td>
                                            <span className="d-md-none">
                                                <strong>{t("Concepto")}</strong>
                                            </span> Obtención en la WEB
                                        </td>
                                        <td>
                                            <span className="d-md-none">
                                                <strong>{t("Puntos totales")}</strong>
                                            </span>
                                            <span>100</span>
                                        </td>
                                        <td>
                                            <span className="d-md-none">
                                                <strong>{t("Noches")}</strong>
                                            </span>
                                        </td>
                                        <td>
                                            <span className="d-md-none">
                                                <strong>{t("Fecha caducidad")}</strong>
                                            </span>24/04/28
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            <c-rw-ap-pagination className="mb-6 mb-md-5 d-block" _nghost-ng-c2017506314="">
                                <div _ngcontent-ng-c2017506314="" className="c-rw-ap-pagination">
                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-back">
                                        <img _ngcontent-ng-c2017506314="" loading="lazy" alt="Icono chevron down" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-left.svg" />
                                    </button>
                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-number active">1</button>

                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-next">
                                        <img _ngcontent-ng-c2017506314="" loading="lazy" alt="Icono chevron down" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-right.svg" />
                                    </button>
                                </div>

                            </c-rw-ap-pagination>

                        </rw-area-privada-points>

                        <rw-area-privada-bookings style={{ display: activeSeccion === "MIS RESERVAS" ? "block" : "none" }}>
                            <table className="o-rw-table">
                                <thead>
                                    <tr>
                                        <th className="text-start">
                                            <strong>{t("Fecha Entrada")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Fecha Salida")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Propiedad")}</strong>
                                        </th>
                                        <th className="text-center">
                                            <strong>{t("Noches")}</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reservas.map((unareserva) => (
                                        <tr key={unareserva.id}>
                                            <td>
                                                <span className="d-md-none">
                                                    <strong>{t("Fecha Entrada")}</strong>
                                                </span>{new Date(unareserva.inicio).toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}
                                            </td>
                                            <td>
                                                <span className="d-md-none">
                                                    <strong>{t("Fecha Salida")}</strong>
                                                </span> {new Date(unareserva.final).toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}
                                            </td>
                                            <td>
                                                <span className="d-md-none">
                                                    <strong>{t("Propiedad")}</strong>
                                                </span>
                                                <span>{unareserva.propiedad.nombre}</span>
                                            </td>
                                            <td>
                                                <span className="d-md-none">
                                                    <strong>{t("Noches")}</strong>
                                                </span> {(new Date(unareserva.final).getTime() - new Date(unareserva.inicio).getTime()) / 1000 / 60 / 60 / 24}
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </table>
                        </rw-area-privada-bookings>

                        <rw-area-privada-promotions style={{ display: activeSeccion === "PROMOCIONES" ? "block" : "none" }}>
                            <div className="mb-6 c-rw-ap-tabs mb-md-1000">
                                <div className="c-rw-ap-tabs_header">
                                    <div ngbnav="" className="nav c-rw-ap-tabs_nav" role="tablist">
                                        <div className="nav-item" role="presentation">
                                            <button type="button" ngbnavlink="" className="nav-link btn rw-btn btn-outline-rewards active" id="ngb-nav-7" role="tab" aria-controls="ngb-nav-7-panel" aria-selected="true" aria-disabled="false">{t("PROMOCIONES")}</button>

                                        </div>

                                        {/* <div className="nav-item" role="presentation">
                                            <button type="button" ngbnavlink="" className="nav-link btn rw-btn btn-outline-rewards" id="ngb-nav-8" role="tab" tabIndex="-1" aria-selected="false" aria-disabled="false">{t("PARTNERS")}</button>

                                        </div>*/}


                                    </div>
                                    {/* <div className="form-check form-switch form-check-reverse color-h10grey form-check-start">
                                        <input type="checkbox" role="switch" id="flexSwitchCheckChecked" className="form-check-input ng-untouched ng-pristine ng-valid" />
                                        <label htmlFor="flexSwitchCheckChecked" className="form-check-label d-flex align-items-center">
                                            <i className="fa-solid fa-gem"></i> {t("Exclusivo socios")}
                                        </label>
                                    </div>*/}

                                </div>
                                <div className="mt-2 tab-content">
                                    <div ngbnavpane="" className="tab-pane fade show active" id="ngb-nav-7-panel" role="tabpanel" aria-labelledby="ngb-nav-7">
                                        <p className="mx-900">
                                            {t("Estas son las promociones disponibles para ti en este momento. ¡No dejes pasar la oportunidad!")}
                                        </p>

                                        <h3 className="mt-6 text-center h4 text-rewards text-md-start">PROMOCIONES </h3>
                                        <div className="row">
                                            {/* <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/6.6_OCMHotelExterior.jpg" alt="Vista general del hotel" />
                                                        <figcaption>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">
                                                            <strong>Ocean Allure Costa Mujeres - Desde $304</strong>
                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 06/05/26 a 21/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/03.7_HPLLobby7.JPG" alt="Atrio del hotel" />
                                                        <figcaption>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">
                                                            <strong>Palacio Colomera - Desde 140€</strong>
                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 22/04/26 a 06/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/00.1_OMRAerialView10.jpg" alt="Vista general del hotel" />
                                                        <figcaption>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">
                                                            <strong>Ocean Maya Royale - Desde $237</strong>
                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 22/04/26 a 06/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/02_HODPool2.jpg" alt="Vista general del hotel y la piscina" />
                                                        <figcaption>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">
                                                            <strong>Ocean Dreams - Desde 151€</strong>
                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 22/04/26 a 06/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/05_TMPHotel.jpg" alt="Vistas hotel" />
                                                        <figcaption>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">
                                                            <strong>The One Monumental Palace - Desde 513€</strong>
                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 06/05/26 a 21/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mb-6 col-sm-6 col-lg-4">
                                                <div className="c-rw-card r-3-4">
                                                    <figure className="c-rw-card_img">
                                                        <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T11D3/05.2_HPLPlungePool5.jpg" alt="Plunge Pool" />
                                                        <figcaption>
                                                            <span className="c-rw-card_img-txt font-heading">Vive la magia de Córdoba esta primavera</span>


                                                        </figcaption>
                                                    </figure>
                                                    <div>
                                                        <p className="mb-2 c-rw-card_title mb-md-3">

                                                            <strong>Vive la magia de Córdoba esta primavera</strong>

                                                        </p>
                                                        <p className="mb-3 color-h10grey mb-md-4">Periodo: 24/04/26 a 12/05/26 </p>
                                                        <button type="button" className="btn rw-btn btn-rewards">LO QUIERO</button>
                                                    </div>
                                                </div>
                                            </div>

                                            */}
                                        </div>
                                        {/* <button type="button" aria-controls="collapseExample" className="mx-auto btn btn-link color-h10grey d-flex mt-md-6">
                                            <span>{t("VER MÁS")}</span>
                                        </button>
                                        */}
                                    </div>



                                </div>
                            </div>


                        </rw-area-privada-promotions>

                        <rw-area-privada-notifications style={{ display: activeSeccion === "NOTIFICACIONES" ? "block" : "none" }}>
                            <div className="row">
                                {/* <div className="col-md-12">
                                    <div className="c-rw-card r-16-9 d-flex flex-sm-row mb-md-4">
                                        <figure className="c-rw-card_img">
                                            <img loading="lazy" className="back" src="https://pro-static.h10hotels.com/gallery/T2D3/cheerz_album-voyage_packshot_10.jpg" alt="" />
                                        </figure>
                                        <div>
                                            <p className="mb-3 c-rw-card_title">{t("¡30% de dto. en Cheerz! Inmortaliza tus viajes en álbumes y recuerdos. Descubre tu código en el apartado Partners de H10 Rewards.")}</p>
                                            <p className="mb-3 color-h10grey mb-md-5">Periodo: 06/05/26 a 31/05/26</p>
                                            <a className="btn rw-btn btn-rewards w-fit" href="https://www.h10hotels.com/es/h10-rewards/privado/promociones" target="_blank">{t("DESCUBRE MÁS")}</a>
                                        </div>
                                    </div>
                                </div>*/}

                            </div>
                            {/* <c-rw-ap-pagination className="mb-6 d-block" _nghost-ng-c2017506314="">
                                <div _ngcontent-ng-c2017506314="" className="c-rw-ap-pagination">
                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-back">
                                        <img _ngcontent-ng-c2017506314="" loading="lazy" alt="Icono chevron down" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-left.svg" />
                                    </button>
                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-number active">1</button>

                                    <button _ngcontent-ng-c2017506314="" type="button" className="btn btn-next">
                                        <img _ngcontent-ng-c2017506314="" loading="lazy" alt="Icono chevron down" src="https://pro-static.h10hotels.com/templates/H10/src/icons/chevron-right.svg" />
                                    </button>
                                </div>

                            </c-rw-ap-pagination>*/}
                        </rw-area-privada-notifications>

                        <rw-area-privada-help style={{ display: activeSeccion === "AYUDA" ? "block" : "none" }}>
                            <div className="o-rw-title-logo not-border small">
                                <figure>
                                    {
                                        config.logo !== "" ?
                                            <img loading="lazy" className="mx-auto mb-6 d-none d-md-block" src={ruta + "/web/logo/web/" + config.logo} style={{ maxWidth: "200px" }} />
                                            :
                                            config.logo_fiscal != "" ?
                                                <img loading="lazy" className="mx-auto mb-6 d-none d-md-block" src={ruta + "/web/logo/" + config.logo_fiscal} style={{ maxWidth: "200px" }} />
                                                :
                                                <img loading="lazy" className="mx-auto mb-6 d-none d-md-block" src="https://www.bedloop.com/imatges/logo.webp" style={{ maxWidth: "200px" }} />
                                    }

                                </figure>
                                <h2>{t("PREGUNTAS FRECUENTES")}</h2>
                            </div>
                            <reward-faq>
                                <div ngbaccordion="" className="mb-5 accordion c-rw-accordion">

                                    {faqs.map((faq, index) => (

                                        <div className="accordion-item" id={faq.id} key={faq.id}>
                                            <div role="heading" ngbaccordionheader="" className={`accordion-header ${faqOpen != faq.id ? 'collapsed' : ''}`}>
                                                <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id={`${faq.id}-toggle`} aria-controls={`${faq.id}-collapse`} aria-expanded={faqOpen == faq.id} onClick={() => setFaqOpen(faqOpen === faq.id ? mull : 0)}>
                                                    <p>{faq.pregunta[lang]}</p>
                                                </button>
                                            </div>
                                            <div role="region" ngbaccordioncollapse="" className={`accordion-collapse collapse ${faqOpen == faq.id ? 'show' : ''}`} id={`${faq.id}-collapse`} aria-labelledby={`${faq.id}-toggle`}>
                                                <div ngbaccordionbody="" className="accordion-body" dangerouslySetInnerHTML={{ __html: faq.respuesta[lang] }}>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </reward-faq>
                        </rw-area-privada-help>

                    </div>
                </div>

            </div>
        </>
    );
}

export default DatosPrivados;
